import React from "react";
import { Link } from "react-router-dom";
import "./Plans.css";

const plans = [
  {
    title: "Tu menú semanal, listo y sin esfuerzo",
    description:
      "Wayo genera tu plan de alimentación personalizado según tus calorías, macros y objetivo. Sin contar, sin improvisar.",
    img: "/assets/img/calendario-menu.webp",
  },
  {
    title: "Nutrición + entrenamiento en una sola app",
    description:
      "La única app que combina tu plan de alimentación con rutinas de gym o en casa adaptadas a tu nivel. ",
    img: "/assets/img/rutinas.webp",
    highlight: true,
  },
  {
    title: "Tu objetivo. Tu plan. Sin excusas.",
    description:
      "¿Perder peso? ¿Ganar músculo? Wayo adapta tu nutrición y entrenamientos a lo que quieres conseguir. Solo síguelo.",
    img: "/assets/img/calendario-detalle.webp",
  },
];

export default function Plans() {
  return (
    <section id="planes" className="plans">
      <div className="plans-container">

        <div className="plans-header">
          <span className="plans-badge">Planes personalizados</span>
          <h2 className="plans-title">
            Alimentación y entrenamiento{" "}
            <span className="plans-title-highlight">diseñados para ti</span>
          </h2>
          <p className="plans-subtitle">
            No solo cuentes calorías. Recibe un plan completo de nutrición y
            entrenamiento adaptado a tu cuerpo y tu objetivo.
          </p>
        </div>

        <div className="plans-grid">
          {plans.map((plan, i) => (
            <article
              key={i}
              className={`plan-card${plan.highlight ? " plan-card--highlight" : ""}`}
              style={{ "--accent": plan.accent }}
            >
              {plan.highlight && (
                <div className="plan-card-ribbon">Solo en Wayo</div>
              )}

              <div className="plan-card-img-wrap">
                <img src={plan.img} alt={plan.title} className="plan-card-img" />
              </div>

              <div className="plan-card-body">
                <span
                  className="plan-card-badge"
                  style={{ background: plan.badgeColor + "22", color: plan.badgeColor, border: `1px solid ${plan.badgeColor}44` }}
                >
                  {plan.badge}
                </span>
                <h3 className="plan-card-title">{plan.title}</h3>
                <p className="plan-card-desc">{plan.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="plans-cta">
          <a
            href="https://wayoai.app/download?utm_source=website&utm_medium=button&utm_campaign=plans"
            className="plans-cta-btn"
          >
            Empieza con tu plan gratis
          </a>
          <p className="plans-cta-note">7 días Premium gratis · Sin límites</p>
          <p className="plans-cta-note">
            o <Link to="/premium" style={{ color: "#3761e8", fontWeight: 600 }}>hazte Premium desde la web</Link>
          </p>
        </div>

      </div>
    </section>
  );
}
